<script lang="ts">
	import AppContainer from '../../components/AppContainer.svelte';
	import Text from '../../components/Text.svelte';
	import LookalikeSelect from '../../components/Segments/New/LookalikeSelect.svelte';
	import Select from 'svelte-select';
	import Button from '../../components/Button.svelte';
	import { getClient, mutate } from 'svelte-apollo';
	import { mutationCreateLookalikeModelRow } from '../../graphql/queries/lookalike';
	import Dialog, { Title, Content, Actions } from '@smui/dialog/styled';
	import { APP_PATHS } from '../../constants';
	import { Link } from 'svelte-routing';

	const client = getClient();

	let trackingPoint = { value: '', label: '' };
	let dmpSegment = { value: '', label: '' };
	let days = { value: '7', label: '7' };
	let okDialog = false;
	let errorMessage: string;
	let errorDialog = false;

	$: {
		if (dmpSegment.value !== '') {
			trackingPoint = { value: '', label: '' };
		}
		if (trackingPoint.value !== '') {
			dmpSegment = { value: '', label: '' };
		}
	}

	function handleError(errMsg: string) {
		errorMessage = errMsg;
		errorDialog = true;
		console.error('Error during creating of user', errMsg);
	}

	const createLookalikeModelRowOp = (values: {
		lookalikeId: string;
		days?: string;
		lalType: string;
	}) => {
		const { lookalikeId, days, lalType } = values;
		return new Promise((resolve) =>
			mutate(client, {
				mutation: mutationCreateLookalikeModelRow,
				variables: {
					lookalikeId: lookalikeId,
					days: days,
					lalType: lalType
				},
				errorPolicy: 'all'
			})
				.then((dataResponse) => {
					resolve(dataResponse);
				})
				.catch((err) => {
					console.warn(err);
					resolve({ errors: err });
				})
		);
	};

	const handleSubmit = async () => {
		if (trackingPoint.value === '' && dmpSegment.value === '') {
			alert('Please select Trackingpoint or DMP Segment for lookalike');
		} else {
			const lookalikeId =
				trackingPoint.value === ''
					? atob(dmpSegment.value).replace('SegmentType:', '')
					: trackingPoint.value;
			const lookalikeType = trackingPoint.value === '' ? 'DMP' : 'TP';
			return createLookalikeModelRowOp({
				lookalikeId: lookalikeId,
				days: days.value,
				lalType: lookalikeType
			})
				.then(() => {
					okDialog = true;
				})
				.catch((err) => {
					handleError(err.message);
				});
		}
	};
</script>

<AppContainer>
	<Text gutter type="headline4">Lookalike targeting - create new list</Text>
	<div class="lookalike-wrapper">
		<LookalikeSelect bind:dmpSegment />
		{#if trackingPoint.value !== ''}
			<div class="select-part">
				<span class="label">Days before trackingpoint:</span>
				<Select
					selectedValue={days}
					items={[
						{ value: '1', label: '1' },
						{ value: '3', label: '3' },
						{ value: '7', label: '7' },
						{ value: '14', label: '14' },
						{ value: '21', label: '21' },
						{ value: '30', label: '30' },
						{ value: '60', label: '60' },
						{ value: '90', label: '90' }
					]}
					on:select={(e) => {
						days = e.detail;
					}}
				/>
			</div>
		{/if}
		<div class="select-part">
			<Button variant="raised" on:click={handleSubmit}>Create</Button>
		</div>
	</div>
</AppContainer>

<Dialog
	open={okDialog}
	aria-labelledby="dialog-title"
	aria-describedby="dialog-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-title">Everything is OK!</Title>
	<Content id="dialog-content">
		Your lookalike targeting list will be generated. Usually it takes about 2 hours.<br /><br
		/>After that, you can see detail in the
		<Link to={APP_PATHS.LOOKALIKE_MODEL}>Overview section</Link>.
	</Content>
</Dialog>

<Dialog
	open={errorDialog}
	aria-labelledby="dialog-title"
	aria-describedby="dialog-content"
	scrimClickAction=""
	escapeKeyAction=""
>
	<Title id="dialog-title">There was some error during your action</Title>
	<Content id="dialog-content">{errorMessage}</Content>

	<Actions>
		<Button on:click={() => (errorDialog = false)}>Close</Button>
	</Actions>
</Dialog>

<style lang="scss">
	.lookalike-wrapper {
		max-width: 450px;
	}

	.select-part {
		padding-left: 20px;
		padding-top: 20px;
		padding-right: 20px;
	}

	.select-part .label {
		display: block;
		margin-bottom: 10px;
	}
</style>
